module.exports = __webpack_public_path__ + "logo.png?8868ce7962953b3a6911ce057947b975";